/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateScheduleResponse {
    getFixupPrototypeFunction() { return CreateScheduleResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateScheduleResponse>): CreateScheduleResponse {
        let obj = Object.assign(new CreateScheduleResponse(), model);
        CreateScheduleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateScheduleResponse>): CreateScheduleResponse {
        if (!model) return null;
        return CreateScheduleResponse.newInstance(<CreateScheduleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateScheduleResponse) {
        if (!obj) return;

        models.CreateScheduleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateScheduleResponse): boolean {
        Object.setPrototypeOf(obj, CreateScheduleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Schedule ID
     */
    schedule_id: string;

}
